import { StyleSheet, View } from "react-native";

import Text from "@components/CustomText";

import React from "react";
import color from "@constants/color";
import OrderStatus from "@assets/svg/OrderStatus";

function DeliveredFooter({ footer }) {
  return (
    <View style={styles.footer}>
      <OrderStatus
        orderStatus="OrderSuccessful"
        orderStatusColor={footer?.title_color}
      />
      <View style={{ marginLeft: 8 }}>
        <Text
          variant="body_text_4"
          style={{
            color: footer?.title_color,
          }}
        >
          {footer?.title}
        </Text>

        <Text
          variant="caption_2"
          style={{
            color: color.mediumBlacklightBlack,
          }}
        >
          {footer?.body}
        </Text>
      </View>
    </View>
  );
}

export default DeliveredFooter;

const styles = StyleSheet.create({
  footer: {
    flexDirection: "row",
    padding: 16,
    alignItems: "flex-start",
    paddingVertical: 12,
  },
});
